import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "apnaartist2-mumbai";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBCgMbQN1ABIo6RJXw4m8WI1iHfGRCb0gI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || `${projectId}.firebaseapp.com`,
  projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "apnaartist2-mumbai.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "976891791263",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:976891791263:web:18ddc95fc7523be2c81faa",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-VCH7Y7SVEL"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
